import { ShareButtons } from 'components/atoms';
import { Footer, Header, Suche, ToastNotificationStack } from 'components/molecules';
import React from 'react';
import { useShowSearch } from 'utils/hooks/state';

import css from './Layout.module.scss';

interface ProfileLayoutProps 
{
  children: React.ReactNode;
}

const ProfileLayout: React.FC<ProfileLayoutProps> = (props) =>
{
  const { children } = props;

  const { showSearch } = useShowSearch();

  return (
    <div className={css.profile}>
      <Header />

      {showSearch && (
        <>
          <div className={css.searchContainer}>
            <Suche />
          </div>
          <hr />
        </>
      )}

      {/* Content */}
      <main className={css.content}>
        { children }
      </main>

      <div className={css.share}>
        <ShareButtons size="large" />
      </div>

      <Footer />
      <ToastNotificationStack />
    </div>
  );
};

export default ProfileLayout;
